import { withAssetVersion } from "@/lib/assets";

/** Site-wide config (stage 4; stage 5 → merge from content JSON `site`). */
export const siteConfig = {
  heroTagline: "正在为200+ 同学服务",
  contact: {
    /** 管家微信二维码；空则显示装饰占位 */
    qrImage: withAssetVersion("/images/site/wechat-qr.png"),
    subtitle:
      "一个微信,问到底——预算、片区、合同、落地,都可以问。",
    replyTimeHint: "回复速度通常 ≤ 30分钟",
    scanHint: "长按识别二维码 · 或截图保存",
  },
} as const;
